
import $http from '@/utils/request'
import $api from '@/libs/api'
import cookie from 'js-cookie'

export default function (appConfig) {
    let Obj = {};
    // 获取配置的mvnoCode等参数列表
    Obj.getMvno = function (giso) {
        let url = $api.interfaces.getMvno;
        if(giso) url += "?giso=" + giso;
        return $http.post(url, {},{ notShowLoading: true });
    };
    // 获取mvnoCode等参数列表的具体参数值
    Obj.getMvnoParam = function (key, obj) {
        for (let k in obj) {
            if (obj.hasOwnProperty(k)) {
                if (key === k) {
                    return obj[k];
                }
            }
        }
        return '';
    };
    // CMS资源相对路径转成绝对路径
    Obj.getCMSImgPath = function (a) {
        const myUrl = appConfig.myUrl;
        let reg = new RegExp(/http[s]?:\/\//);
        if (reg.test(a)) {
            // 绝对路径直接返回
            return a;
        }
        return a ? myUrl + a.replace(/^[.\/]*/, '') : '';
    };
    // 获取用户信息
    Obj.getUserInfo = function (obj) {
        return $http.post($api.member.userInfo, obj);
    };
    // 价格转换
    Obj.YuanToFen = function (price) {
        return price ? price * 100 : '0';
    };
    /**
     * @return {string}
     */
    Obj.FenToYuan = function (price) {
        if (price) {
            let temp_price = parseInt(price) / 100 + '';
            let arr = temp_price.split('.');
            arr[1] = ((arr[1] || '') + '00');
            for(let i = 0; i < arr.length; i++){
                arr[i] = arr[i].replace(/[^0-9\-]/,'');
            }
            arr[1] = arr[1].substr(0, 2);
            return arr.join('.');
        } else {
            return '0.00';
        }
    };
    // 流量转换
    /**
     * @return {string}
     */
    Obj.ByteToMB = function (byte) {
        return byte ? (byte / (1024 * 1024)).toFixed(2) : '0';
    };
    /**
     * @return {string}
     */
    Obj.MBToGB = function (mb) {
        if (0 <= mb && mb < 1024) {
            return mb + 'M';
        } else if (1024 <= mb && mb <= 999999) {
            return Math.floor(mb / 1024) +'G';
        } else {
            return 'GB';
        }
    };
    Obj.toFixed2 = function(mb) {  //mb保留两位小数
        if (mb && mb !== 0) {
            return mb.toFixed(2);
        } else {
            return 0;
        }
    };
    //转换时间long格式到yyyy-mm-dd hh-MM-ss
    Obj.getFormatTime = function (d) {
        if (!d) {
            return;
        }
        let date = new Date(d);
        let Y = date.getFullYear() + '-';
        let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
        M = M < 10 ? "0" + M : M;
        let D = (date.getDate() + ' ') < 10 ? "0" + (date.getDate() + ' ') : (date.getDate() + ' ');
        let h = date.getHours();
        h = (h < 10 ? "0" + h : h)+ ':';
        let m = date.getMinutes();
        m = (m < 10 ? "0" + m : m)+ ':';
        let s = date.getSeconds();
        s = (s < 10 ? "0" + s : s);
        return Y + M + D + h + m + s;
    };
    //获取当前时间转换格式到yyyyMMddhhmmssSSS
    Obj.getMillisecondsFormat = function () {
        let date = new Date();
        let y = date.getFullYear();
        let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1);
        let d = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
        let h = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
        let m = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
        let s = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
        let S = date.getMilliseconds();
        if (S < 10) {
            S = "00" + S;
        } else if (S < 100) {
            S = "0" + S;
        }

        return '' + y + M + d + h + m + s + S;
    };
    // cookie language语言值修正
    Obj.getLanguage = function (lang) {
        if (lang === "zh-CN" || lang === "zh-TW" || lang === "zh-HK" || lang === "en-US") {
            return lang;
        } else {
            return "zh-CN";
        }
    };
    //支付时的3D验证开关配置化
    Obj.threeDSecureBtn = function () {
        const btnFlag = appConfig.threeDSecureBtn;
        return btnFlag;
    };
    // rent device iframe url
    Obj.apiDomain = function () {
        return appConfig.api_domain || '';
    };

    return Obj;
}



// WEBPACK FOOTER //
// ./src/assets/js/common/common.js